import { useMemo } from 'react'
import { useDashboardData } from '../../../../api/useFreight/useDashboard'

import type { DashboardMetrics } from '../../../../api/useFreight/types/dashboard'
import type { CostRevenueType } from '../types'

interface LaunchpadDataResult {
  data: DashboardMetrics | null
  isLoading: boolean
}

/**
 * Hook to fetch and process dashboard data for the Launchpad
 * @param costRevenue The current cost/revenue selection
 * @returns Object containing data and loading state
 */
export const useLaunchpadData = (costRevenue: CostRevenueType): LaunchpadDataResult => {
  const { data, isLoading } = useDashboardData({ costRevenue })

  // We could add more processing here if needed
  const processedData = useMemo(() => {
    // Return the data as is for now, but we can add transformations if needed
    return data
  }, [data])

  return {
    data: processedData,
    isLoading,
  }
}
